import { useEffect, useRef, useState } from 'react';
import { engine } from '../audio/engine';

/** Transport position in beats, sampled once per frame. */
export function useBeat(): number {
  const [beat, setBeat] = useState(0);
  useEffect(() => {
    let raf = 0;
    const loop = () => {
      raf = requestAnimationFrame(loop);
      setBeat(engine.beatNow());
    };
    loop();
    return () => cancelAnimationFrame(raf);
  }, []);
  return beat;
}

export function usePlaying(): boolean {
  const [playing, setPlaying] = useState(engine.isPlaying);
  useEffect(() => engine.subscribe({ onStateChange: setPlaying }), []);
  return playing;
}

/** Element size, kept in sync with ResizeObserver. */
export function useSize<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setSize({ width: entry.contentRect.width, height: entry.contentRect.height });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return { ref, ...size };
}
